import { string } from 'yup'
import { FORMATTED_PHONE_REGEX } from 'utils/formatPhone'

export const cellPhoneSchema = string()
  .matches(FORMATTED_PHONE_REGEX, 'Please enter a valid cellphone number.')
  .required('This field is required')
